import { render } from "./DiscountForm.vue?vue&type=template&id=9e3f5934&scoped=true"
import script from "./DiscountForm.vue?vue&type=script&lang=js"
export * from "./DiscountForm.vue?vue&type=script&lang=js"

import "./DiscountForm.vue?vue&type=style&index=0&id=9e3f5934&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e3f5934"]])

export default __exports__